import { h } from 'preact'
import { useStateValue } from '../../state-management/store'
import { changeStep } from '../../state-management/actions'
import { BookingStep } from '../../models/enums'
import { StepBody } from '../step-body'
import { SelfSchedulerFooter } from '../self-scheduler-footer'
import { PatientForm } from '../patient-form'
import * as style from './style.css'

const NewPatientForm: preact.FunctionalComponent = () => {
    const [{ patientDetails, submitting, showAdditionalDetailsForm }, dispatch] = useStateValue()

    const isValid = Object.values(patientDetails).every((field) => field.isValid)

    const submitHandler = async () => {
        if (!isValid) {
            return
        }

        changeStep(dispatch, showAdditionalDetailsForm ? BookingStep.ADDITIONAL_INFO : BookingStep.DATETIME)
    }

    return (
        <section class={style.patientFormContainer}>
            <StepBody>
                <div class={style.patientFormWrapper}>
                    <PatientForm />
                </div>
            </StepBody>
            <SelfSchedulerFooter
                backStep={BookingStep.PATIENT_TYPE}
                onNext={submitHandler}
                isNextDisabled={!isValid || submitting}
            />
        </section>
    )
}

export default NewPatientForm
